import { render, staticRenderFns } from "./TableDdlFunction.vue?vue&type=template&id=2af4f5b0&"
import script from "./TableDdlFunction.vue?vue&type=script&lang=js&"
export * from "./TableDdlFunction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TableDdlFunction.vue"
export default component.exports